export default __webpack_public_path__ + "static/media/advimg_s.bf1e660f.png";